import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNetworkRequest } from './useNetworkRequest';

export const useMaskedPhoneNumberMutations = () => {
  const { axios } = useNetworkRequest();
  const queryClient = useQueryClient();
  const { mutate: requestJobMaskedNumber, isLoading: isJobLoading } = useMutation(
    (jobId: number) => axios.post(`/v3/professional/jobs/${jobId}/phone_number`),
    {
      onSuccess: async () => {
        await Promise.all([
          queryClient.invalidateQueries({ queryKey: ['GetJobForJobDetailsContainer'] }),
          queryClient.invalidateQueries({ queryKey: ['jobs'] }),
        ]);
      },
    },
  );
  const { mutate: requestAssignmentMaskedNumber, isLoading: isAssignmentLoading } = useMutation(
    (assignmentId: number) =>
      axios.post(`/v3/professional/assignments/${assignmentId}/phone_number`),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: ['GetAssignmentForAssignmentDetails'],
        });
      },
    },
  );
  return {
    requestJobMaskedNumber,
    requestAssignmentMaskedNumber,
    isLoading: isJobLoading || isAssignmentLoading,
  };
};
